import { render, staticRenderFns } from "./ViewCouponEntries.vue?vue&type=template&id=2874ed14&"
import script from "./ViewCouponEntries.vue?vue&type=script&lang=js&"
export * from "./ViewCouponEntries.vue?vue&type=script&lang=js&"
import style0 from "./ViewCouponEntries.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ViewCouponEntries.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports